/**
 * Central timings and counts for STOMP connect, heartbeat, JOIN, and reconnect.
 * Change values here — do not hardcode them in StompAdaptor / BaseGameController.
 */
export const CONNECTION_CONFIG = {
  connection: {
    connectTimeoutMs: 8000,
    bootstrapTimeoutMs: 60000,
    deactivateTimeoutMs: 2000,
  },

  heartbeat: {
    enabled: true,
    pingIntervalMs: 5000,
    pongTimeoutMs: 2500,
    maxMissedPongs: 2,
  },

  gameWatchdog: {
    enabled: true,
    tickStaleTimeoutMs: 3000,
    checkIntervalMs: 1000,
  },

  reconnect: {
    initialDelayMs: 500,
    backoffMultiplier: 2,
    maxDelayMs: 5000,
    jitterMs: 250,
    maxAttempts: 15,
  },

  join: {
    ackTimeoutMs: 5000,
    maxRetries: 3,
  },

  network: {
    onlineReconnectDelayMs: 500,
  },

  ui: {
    /** Time on the reconnecting overlay before Refresh is offered. Reconnect keeps running. */
    longFailureThresholdMs: 60000,
  },

  lifecycle: {
    pauseWatchdogsWhenHidden: true,
  },
} as const;

export type ConnectionConfig = typeof CONNECTION_CONFIG;

export const CONNECTION_FAILURE_REASON = {
  SOCKET_CLOSED: 'SOCKET_CLOSED',
  SOCKET_ERROR: 'SOCKET_ERROR',
  STOMP_ERROR: 'STOMP_ERROR',
  NETWORK_OFFLINE: 'NETWORK_OFFLINE',
  NETWORK_ONLINE: 'NETWORK_ONLINE',
  NETWORK_CHANGED: 'NETWORK_CHANGED',
  PONG_FAILURE: 'PONG_FAILURE',
  HEARTBEAT_TIMEOUT: 'HEARTBEAT_TIMEOUT',
  TICK_STALE: 'TICK_STALE',
  CONNECT_TIMEOUT: 'CONNECT_TIMEOUT',
  JOIN_TIMEOUT: 'JOIN_TIMEOUT',
  VISIBILITY_RESUME: 'VISIBILITY_RESUME',
} as const;

export type ConnectionFailureReason =
  (typeof CONNECTION_FAILURE_REASON)[keyof typeof CONNECTION_FAILURE_REASON];
